module.exports = __webpack_public_path__ + "images/mdj/members/resume/mobile/icon_lock2-6b14133f2575f4ed582a9f21deeb7c4f.png";